import { Stink } from './Stink'

export const virus_colors: { [key: string]: string } = {
  influenza: '#DE666F',
  'sars-cov-2': '#FFE462',
  adenovirus: '#95D0CF',
  rhinovirus: '#E78D38',
  respiratory_syncytial_virus: '#69AACD',
  other: '#cccccc',
}

export const virusnames: { [key: string]: { de: string; fr: string } } = {
  influenza: { de: 'Influenza', fr: 'Grippe' },
  'sars-cov-2': {
    de: 'Sars-CoV-2',
    fr: 'SARS-CoV-2',
  },
  adenovirus: {
    de: 'Adenovirus',
    fr: 'Adénovirus',
  },
  rhinovirus: {
    de: 'Rhinovirus',
    fr: 'Rhinovirus',
  },
  respiratory_syncytial_virus: {
    de: 'RSV',
    fr: 'VRS',
  },
  other: {
    de: 'Andere',
    fr: 'Autres',
  },
}

export const global_locales: { [key: string]: any } = {
  hospitalized: {
    de: {
      title:
        'Neue Hospitalisierungen im Zusammenhang mit Covid und Grippe, pro Woche',
      lead: (
        <>
          Seit 2018 werden die Influenza-Hospitalisierungen im{' '}
          <Stink href='https://www.bag.admin.ch/bag/de/home/krankheiten/ausbrueche-epidemien-pandemien/aktuelle-ausbrueche-epidemien/respiratorische-viren.html#1754112018'>
            spitalbasierten Sentinel-Überwachungssystem
          </Stink>{' '}
          erfasst. 2020 wurde das System um Covid-19 erweitert. Derzeit melden
          schweizweit nur noch 6 Spitäler Daten, um schwere Krankheitsverläufe
          zu überwachen. Aufgrund der kleinen Anzahl meldender Einrichtungen
          kann diese Datenreihe nur zur Trendbewertung genutzt werden.
        </>
      ),
      source:
        'Quelle: Covid-19 and Influenza Hospital Based Surveillance CH-SUR',
      frequency: '(immer donnerstags)',
    },
    fr: {
      title:
        'Nouvelles hospitalisations liées au Covid et à la grippe, par semaine',
      lead: "Depuis 2018, les hospitalisations pour grippe sont enregistrées dans le système de surveillance Sentinella basé sur les hôpitaux. En 2020, le système a été étendu au Covid-19. Actuellement, seuls 6 hôpitaux dans toute la Suisse déclarent encore des données pour surveiller les évolutions graves de la maladie. En raison du petit nombre d'établissements déclarants, cette série de données ne peut être utilisée que pour évaluer les tendances.",
      source:
        'Source: Covid-19 et surveillance hospitalière de la grippe CH-SUR',
      frequency: '(tous les jeudis)',
    },
  },
  block_titles: {
    de: {
      covid: 'Übersicht Sars-Cov-2 (Covid)',
      influenza: 'Übersicht Influenza (Grippe)',
      rsv: 'Übersicht Respiratorisches Synzytial-Virus (RSV)',
    },
    fr: {
      covid: 'Covid-19',
      influenza: 'Grippe saisonnière',
      rsv: 'VRS (virus respiratoire syncytial)',
    },
  },
  influenzaseasons: {
    de: {
      title: 'Laborbestätigte Influenza-Fälle, pro Woche',
      lead: (
        <>
          Die Grafiken zeigen Daten, die Labors, Ärztinnen sowie Spitäler im
          Rahmen des{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/oblig'>
            obligatorischen Meldesystems
          </Stink>{' '}
          ans BAG übermittelt haben. Rund 60 Infektionskrankheiten werden
          überwacht, darunter auch Covid und Influenza. Da nur ein Teil der
          Erkrankten einen Arzt aufsucht und von diesen nur ein Teil auf virale
          respiratorische Viren getestet wird, ist die Zahl der nicht erkannten
          Erkrankungen (Dunkelziffer) hoch.
        </>
      ),
      source: 'Quelle: Obligatorisches Meldesystem, BAG',
    },
    fr: {
      title: 'Cas de grippe confirmés en laboratoire, par semaine',
      lead: (
        <>
          Chaque ligne correspond à une période de 12 mois démarrant à la fin du
          mois de juin. Les données sont transmises à l’OFSP par les
          laboratoires, les médecins et les hôpitaux dans le cadre du{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/oblig'>
            système de déclaration obligatoire
          </Stink>
          . Une soixantaine de maladies infectieuses sont surveillées, dont le
          Covid-19 et la grippe saisonnière. Comme seule une partie des malades
          consulte un médecin et que seule une partie d’entre eux subit un test
          de dépistage des virus respiratoires, le nombre de maladies non
          détectées (chiffre noir) est élevé.
        </>
      ),
      source: 'Source: Système de déclaration obligatoire, OFSP',
    },
  },
  covidovertime: {
    de: {
      title: 'Laborbestätigte Covid-Fälle, pro Woche',
      lead: (
        <>
          Die Grafiken zeigen Daten, die Labors, Ärztinnen sowie Spitäler im
          Rahmen des{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/oblig'>
            obligatorischen Meldesystems
          </Stink>{' '}
          ans BAG übermittelt haben. Rund 60 Infektionskrankheiten werden
          überwacht, darunter auch Covid und Influenza. Da nur ein Teil der
          Erkrankten einen Arzt aufsucht und von diesen nur ein Teil auf virale
          respiratorische Viren getestet wird, ist die Zahl der nicht erkannten
          Erkrankungen (Dunkelziffer) hoch.
        </>
      ),
      source: 'Quelle: Obligatorisches Meldesystem, BAG',
    },
    fr: {
      title: 'Cas de Covid confirmés en laboratoire, par semaine',
      lead: 'Les graphiques montrent les données transmises par les laboratoires, les médecins et les hôpitaux dans le cadre du système de déclaration obligatoire à l’OFSP. Environ 60 maladies infectieuses sont surveillées, dont le Covid et la grippe. Comme seule une partie des malades consulte un médecin et que seule une partie de ces derniers est testée pour les virus respiratoires, le nombre de cas non détectés (chiffres noirs) est élevé.',
      source: 'Source: Système de déclaration obligatoire, OFSP',
    },
  },
  consultationsovertime: {
    de: {
      title:
        'Geschätzte Arztbesuche wegen Covid oder grippeähnlichen Erkrankungen pro Woche',
      lead: (
        <>
          Ärztinnen und Ärzte übermitteln Informationen aufgrund eines Verdachts
          auf Covid oder Influenza ans BAG. Die Grafik zeigt Erstkonsultationen
          aufgrund einer akuten respiratorischen Infektion (
          <Stink href='https://www.idd.bag.admin.ch/diseases/covid/statistic#consultations'>
            ARI
          </Stink>
          ) in Arztpraxen und bei Hausbesuchen. Aufgrund dieser Meldungen wird
          die wöchentliche Zahl Arztbesuche in der Schweiz geschätzt.
        </>
      ),
      source: 'Quelle: Obligatorisches Meldesystem, BAG',
    },
    fr: {
      title:
        'Estimation du nombre de consultations médicales liées au Covid-19 ou à tout syndrome de type grippal par semaine.',
      lead: (
        <>
          Ces informations sont transmises par les médecins à l’OFSP sur la base
          d’une suspicion de Covid-19 ou d’influenza. Le graphique prend en
          compte les premières consultations en cas d’une infection respiratoire
          aiguë (
          <Stink href='https://www.idd.bag.admin.ch/diseases/covid/statistic#consultations'>
            IRA
          </Stink>
          ) dans les cabinets médicaux et lors de visites à domicile. Le nombre
          de consultations médicales hebdomadaires en Suisse est estimé sur la
          base de ces données.
        </>
      ),
      source: 'Source: Système de déclaration obligatoire, OFSP',
    },
  },
  wastewaterrsv: {
    de: {
      title: 'RSV-Gensequenzen im Abwasser in ausgewählten Kläranlagen',
      lead: 'Tägliche Messwerte und der Trend als 7-Tages-Mittelwert',
      source:
        'Quelle: Eidgenössische Anstalt für Wasserversorgung, Abwasserreinigung und Gewässerschutz (Eawag), BAG',
    },
    fr: {
      title:
        "Séquences génétiques du RSV dans les eaux usées des stations d'épuration",
      lead: 'Valeurs de mesure quotidiennes et tendance en tant que moyenne sur sept jours',
      source:
        "Source: Établissement fédéral pour l'approvisionnement en eau, l'épuration des eaux usées et la protection des eaux (Eawag), OFSP",
    },
  },
  wastewatercovid: {
    de: {
      title: 'Covid-Gensequenzen im Abwasser in ausgewählten Kläranlagen',
      lead: 'Tägliche Messwerte und der Trend als 7-Tages-Mittelwert',
      source:
        'Quelle: Eidgenössische Anstalt für Wasserversorgung, Abwasserreinigung und Gewässerschutz (Eawag), BAG',
    },
    fr: {
      title:
        'Séquences génétiques Covid dans les eaux usées des stations d’épuration',
      lead: 'Valeurs de mesure quotidiennes et tendance en tant que moyenne sur sept jours',
      source:
        "Source: Établissement fédéral pour l'approvisionnement en eau, l'épuration des eaux usées et la protection des eaux (Eawag), OFSP",
    },
  },
  wastewaterinfluenza: {
    de: {
      title: 'Influenza-Gensequenzen im Abwasser in ausgewählten Kläranlagen',
      lead: 'Tägliche Messwerte und der Trend als 7-Tages-Mittelwert',
      source:
        'Quelle: Eidgenössische Anstalt für Wasserversorgung, Abwasserreinigung und Gewässerschutz (Eawag), BAG',
    },
    fr: {
      title:
        "Séquences génétiques de l'influenza dans les eaux usées des stations d’épuration",
      lead: 'Valeurs de mesure quotidiennes et tendance en tant que moyenne sur sept jours',
      source:
        "Source: Établissement fédéral pour l'approvisionnement en eau, l'épuration des eaux usées et la protection des eaux (Eawag), OFSP",
    },
  },
  wastewatertrend: {
    de: {
      step_labels: [
        'stark sinkend',
        'sinkend',
        'keine Veränderung',
        'steigend',
        'stark steigend',
      ],
      title: {
        'sars-cov-2': 'Trends der Sars-Cov-2-Viruslast im Abwasser ',
        influenza: 'Trend der Influenza-Nachweise im Abwasser',
        respiratory_syncytial_virus: 'Trend der RSV-Nachweise im Abwasser',
      },
      lead: 'Entwicklung an den 14 Messstationen',
      virus: {
        'sars-cov-2': 'Sars-Cov-2',
        influenza: 'Influenza',
        influenza_a: 'Influenza A',
        influenza_b: 'Influenza B',
        respiratory_syncytial_virus: 'RSV',
      },
      source: 'Quelle: BAG',
    },
    fr: {
      step_labels: [
        'forte baisse',
        'baisse',
        'stable',
        'hausse',
        'forte hausse',
      ],
      title: {
        'SARS-CoV-2':
          'Tendances de la charge virale du Sras-Cov-2 dans les eaux usées',
        influenza: 'Tendance de la détection de la grippe dans les eaux usées',
        respiratory_syncytial_virus:
          'Tendance des détections de VRS dans les eaux usées',
      },
      virus: {
        'sars-cov-2': 'SARS-CoV-2',
        influenza: 'Influenza',
        influenza_a: 'Influenza A',
        influenza_b: 'Influenza B',
        respiratory_syncytial_virus: 'RSV',
      },
      lead: '14 stations de mesure',
      source: 'Source : OFSP',
    },
  },
  wastewater: {
    de: {
      stations: {
        'Werdhölzli (ZH)':
          "Einzugsgebiet: 450'000 Personen in der Stadt und 6 Gemeinden.",
        'Sensetal, Laupen (BE)':
          "Einzugsgebiet: 62'000 Personen in 25 Gemeinden der Kantone Bern und Freiburg.",
        Genf: "Einzugsgebiet: 454'000 Personen in der Stadt und 31 Gemeinden.",
        Chur: "Einzugsgebiet: 55'000 Personen in der Stadt und 10 Gemeinden.",
        Lugano:
          "Einzugsgebiet: 124'000 Personen in der Stadt und 28 Gemeinden.",
        'Altenrhein (SG)':
          "Einzugsgebiet: 64'000 Personen in 17 Gemeinden der Kantone St. Gallen und Appenzell Ausserrhoden.",
        all: "Gemessene Konzentration in 100 Milliarden Gensequenzen pro 100'000 Einwohner.",
      },
      title: 'Abwassermonitoring',
      lead: (
        <>
          Mit dem nationalen{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/waste-water'>
            Abwassermonitoring
          </Stink>{' '}
          wird die Virenzirkulation von Sars-Cov-2, Influenza A/B und RSV in der
          Bevölkerung überwacht. Die absolute Viruslast in den
          Abwasserreinigungsanlagen entspricht der Anzahl Genfragmente der Viren
          pro Tag. An 14 Stationen wird schweizweit fünf Mal pro Woche gemessen.
          Die Messwerte können schwanken, daher wird ein Durchschnittswert über
          sieben Tage berechnet.
        </>
      ),
    },
    fr: {
      stations: {
        'Werdhölzli (ZH)':
          "Zone de captage: 450'000 personnes dans la ville et 6 communes.",
        'Sensetal, Laupen (BE)':
          "Zone de captage: 62'000 personnes dans 25 communes des cantons de Berne et de Fribourg.",
        Genève:
          "Zone de captage: 454'000 personnes dans la ville et 31 communes.",
        Coire:
          "Zone de captage: 55'000 personnes dans la ville et 10 communes.",
        Lugano:
          "Zone de captage: 124'000 personnes dans la ville et 28 communes.",
        'Altenrhein (SG)':
          "Zone de captage: 64'000 personnes dans 17 communes des cantons de Saint-Gall et d’Appenzell Rhodes-Extérieures.",
        all: "Concentration mesurée en 100 milliards de séquences génétiques pour 100'000 habitants.",
      },
      title: 'Surveillance des eaux usées',
      lead: "La surveillance nationale des eaux usées permet de surveiller la circulation des agents pathogènes dans la population. La figure montre la charge virale du SARS-CoV-2 dans les stations d’épuration. La charge virale absolue correspond au nombre de fragments génétiques des virus par jour. Quatorze stations sont mesurées cinq fois par semaine dans toute la Suisse. Les valeurs de mesure peuvent varier, c'est pourquoi une valeur moyenne est calculée sur sept jours.",
    },
  },
  timestamp: {
    de: { type: 'Aktualisiert' },
    fr: {
      type: 'Mise à jour',
    },
  },
  summarytext: {
    de: {
      title: 'Aktuelle Einschätzung des BAG',
      source: 'Text: Bundesamt für Gesundheit (BAG)',
      showMore: 'Alles zeigen',
      showLess: 'Weniger zeigen',
      frequency: '(immer ab Mittwochmittag)',
    },
    fr: {
      title: 'Evaluation actuelle de l’OFSP',
      source: 'Texte: Office fédéral de la santé publique (OFSP)',
      showMore: 'Voir plus',
      showLess: 'Voir moins',
      frequency: '(actualisé chaque mercredi midi)',
    },
  },
  virusovertime: {
    de: {
      title: 'Nachweise respiratorischer Viren, pro Woche',
      lead: (
        <>
          Eine ausgewählte Ärzteschaft übermittelt im Rahmen des{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/sentinella'>
            Sentinella-⁠Meldesystems
          </Stink>{' '}
          Informationen aufgrund eines Verdachts auf Covid oder Influenza ans
          BAG. Rund ein Drittel dieser Ärztinnen und Ärzte sendet einen
          Nasenrachen-⁠Abstrich ans Nationale Referenzzentrum. Alle Proben
          werden auf Sars-Cov-2, Influenza, RSV und weitere respiratorische
          Viren getestet. Die folgenden Grafiken weisen die wöchentliche Anzahl
          Nachweise und die relative Verteilung aus.
        </>
      ),
      source: 'Quelle: Nationales Referenzzentrum für Influenza, BAG',
    },
    fr: {
      title: 'Détection de virus respiratoires, par semaine',
      lead: 'Dans le cadre du système de déclaration Sentinella, une sélection de médecins transmet à l’OFSP des informations sur les suspicions de Covid et de grippe. Environ un tiers de ces médecins envoie un échantillon de frottis au Centre national de référence. Tous les échantillons sont testés pour le SARS-CoV-2, la grippe, le VRS et d’autres virus respiratoires. Les graphiques suivants montrent le nombre hebdomadaire de détections et leur répartition.',
      source: 'Source: Centre national de référence pour la grippe, OFSP',
    },
  },
  virussharetable: {
    de: {
      title: 'Verteilung der Nachweise respiratorischer Viren, pro Woche',
      lead: (
        <>
          Eine ausgewählte Ärzteschaft übermittelt im Rahmen des{' '}
          <Stink href='https://idd.bag.admin.ch/survey-systems/sentinella'>
            Sentinella-⁠Meldesystems
          </Stink>{' '}
          Informationen aufgrund eines Verdachts auf Covid oder Influenza ans
          BAG. Rund ein Drittel dieser Ärztinnen und Ärzte sendet einen
          Nasenrachen-⁠Abstrich ans Nationale Referenzzentrum. Alle Proben
          werden auf Sars-Cov-2, Influenza, RSV und weitere respiratorische
          Viren getestet. Die folgenden Grafiken weisen die wöchentliche Anzahl
          Nachweise und die relative Verteilung aus.
        </>
      ),
      rank: 'Rang',
      source: 'Quelle: Nationales Referenzzentrum für Influenza, BAG',
    },
    fr: {
      title: 'Répartition des détections de virus respiratoires, par semaine',
      lead: 'Dans le cadre du système de déclaration Sentinella, une sélection de médecins transmet à l’OFSP des informations sur les suspicions de Covid et de grippe. Environ un tiers de ces médecins envoie un échantillon de frottis au Centre national de référence. Tous les échantillons sont testés pour le SARS-CoV-2, la grippe, le VRS et d’autres virus respiratoires. Les graphiques suivants montrent le nombre hebdomadaire de détections et leur répartition.',
      rank: 'Rang',
      source: 'Source: Centre national de référence pour la grippe, OFSP',
    },
  },
  viruscumulated: {
    de: {
      title: 'Nachweise respiratorischer Viren, kumuliert über 2 Jahre',
      lead: 'Am häufigsten wurde Influenza nachgewiesen.',
      source: 'Quelle: Nationales Referenzzentrum für Influenza, BAG',
    },
    fr: {
      title: 'Détection de virus respiratoires, cumulés',
      lead: 'La grippe a été le plus détectée en laboratoire.',
      source: 'Source: Centre national de référence pour la grippe, OFSP',
    },
  },
}
